import { LogicConstraintType } from "../../constants/constants";

export interface IParcelConstraints {
    maxHeightInMm: number;
    maxLengthInMm: number;
    maxWeightInGrams: number;
    maxWidthInMm: number;
    logicConstraintType: LogicConstraintType;
    logicConstraintValue: number;
}

export class ParcelConstraints {
    private readonly _maxHeightInMm: number;
    private readonly _maxLengthInMm: number;
    private readonly _maxWeightInGrams: number;
    private readonly _maxWidthInMm: number;
    private readonly _logicConstraintType: LogicConstraintType;
    private readonly _logicConstraintValue: number;

    constructor(parcelConstraints?: IParcelConstraints) {
        if (parcelConstraints) {
            this._maxHeightInMm = parcelConstraints.maxHeightInMm ?? "";
            this._maxLengthInMm = parcelConstraints.maxLengthInMm ?? "";
            this._maxWeightInGrams = parcelConstraints.maxWeightInGrams ?? "";
            this._maxWidthInMm = parcelConstraints.maxWidthInMm ?? "";
            this._logicConstraintType = parcelConstraints.logicConstraintType ?? "";
            this._logicConstraintValue = parcelConstraints.logicConstraintValue ?? "";
        }
    }

    public get maxHeightInMm(): number {
        return this._maxHeightInMm;
    }

    public get maxLengthInMm(): number {
        return this._maxLengthInMm;
    }

    public get maxWeightInGrams(): number {
        return this._maxWeightInGrams;
    }

    public get maxWidthInMm(): number {
        return this._maxWidthInMm;
    }

    public get logicConstraintType(): LogicConstraintType {
        return this._logicConstraintType;
    }

    public get logicConstraintValue(): number {
        return this._logicConstraintValue;
    }
}
